import api from './api';

const BASE_PATH = '/live_challenges';
const ACTIVATIONS_PATH = '/live_challenge_activations';

// Template (conteúdo do desafio) + entrada do aluno + histórico.
// Controller Rails: api/v1/live_challenges_controller.rb
export const liveChallengesApi = {
  index: () => api.get(BASE_PATH),
  show: id => api.get(`${BASE_PATH}/${id}`),
  create: data => api.post(BASE_PATH, { live_challenge: data }),
  update: (id, data) => api.patch(`${BASE_PATH}/${id}`, { live_challenge: data }),
  destroy: id => api.delete(`${BASE_PATH}/${id}`),
  duplicate: id => api.post(`${BASE_PATH}/${id}/duplicate`),

  // Ativações do template (histórico) + criar ativação (409 = já existe não-finalizada).
  activate: id => api.post(`${BASE_PATH}/${id}/activations`),
  activations: id => api.get(`${BASE_PATH}/${id}/activations`),

  join: accessCode => api.post(`${BASE_PATH}/join`, { access_code: accessCode }),

  // Histórico do aluno logado. Controller Rails: api/v1/live_challenge_participations_controller.rb
  participations: (page = 1) => api.get('/live_challenge_participations', { params: { page } })
};

// Uma rodada ao vivo (estado + participantes + ranking).
// Controller Rails: api/v1/live_challenge_activations_controller.rb
export const liveChallengeActivationsApi = {
  show: id => api.get(`${ACTIVATIONS_PATH}/${id}`),
  start: id => api.post(`${ACTIVATIONS_PATH}/${id}/start`),
  backToLobby: id => api.post(`${ACTIVATIONS_PATH}/${id}/back_to_lobby`),
  revealQuestion: id => api.post(`${ACTIVATIONS_PATH}/${id}/reveal_question`),
  closeQuestion: id => api.post(`${ACTIVATIONS_PATH}/${id}/close_question`),
  finish: id => api.post(`${ACTIVATIONS_PATH}/${id}/finish`),

  answer: (id, alternativeId) => api.post(`${ACTIVATIONS_PATH}/${id}/answer`, { alternative_id: alternativeId }),
  leaderboard: (id, limit = 10) => api.get(`${ACTIVATIONS_PATH}/${id}/leaderboard`, { params: { limit } }),
  myScore: id => api.get(`${ACTIVATIONS_PATH}/${id}/my_score`),
  myResult: id => api.get(`${ACTIVATIONS_PATH}/${id}/my_result`),
  qrData: id => api.get(`${ACTIVATIONS_PATH}/${id}/qr_data`)
};
